module.exports = __webpack_public_path__ + "img/referral.989daddf.png";